'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = ['M32 256c0 28.3 15.9 53 39.4 65.4l11.7 6.2-3.9 12.6c-7.8 25.4-1.6 54.1 18.4 74.1s48.7 26.2 74.1 18.4l12.6-3.9 6.2 11.7C203 464.1 227.7 480 256 480s53-15.9 65.4-39.4l6.2-11.7 12.6 3.9c25.4 7.8 54.1 1.6 74.1-18.4s26.2-48.7 18.4-74.1l-3.9-12.6 11.7-6.2C464.1 309 480 284.3 480 256s-15.9-53-39.4-65.4l-11.7-6.2 3.9-12.6c7.8-25.4 1.6-54.1-18.4-74.1s-48.7-26.2-74.1-18.4l-12.6 3.9-6.2-11.7C309 47.9 284.3 32 256 32s-53 15.9-65.4 39.4l-6.2 11.7-12.6-3.9c-25.4-7.8-54.1-1.6-74.1 18.4s-26.2 48.7-18.4 74.1l3.9 12.6-11.7 6.2C47.9 203 32 227.7 32 256zm108.7 3.3l22.6-22.6L224 297.4 348.7 172.7l22.6 22.6-136 136L224 342.6l-11.3-11.3-72-72z', 'M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4l6.2 11.7 12.6-3.9c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1l-3.9 12.6 11.7 6.2C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4l-11.7 6.2 3.9 12.6c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4l-12.6-3.9-6.2 11.7C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4l-6.2-11.7-12.6 3.9c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1l3.9-12.6-11.7-6.2C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4l11.7-6.2-3.9-12.6c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4l12.6 3.9 6.2-11.7zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM235.3 331.3l136-136-22.6-22.6L224 297.4l-60.7-60.7-22.6 22.6 72 72L224 342.6l11.3-11.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;